import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

// const MIN_WIDTH = '1135px';
const FULL_WIDTH = '100%';

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: ${FULL_WIDTH};
	height: auto;
	padding: 24px 32px;
	background-color: ${colors.white};
	margin-bottom: 32px;
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	min-height: 300px;
`;

export const LoadingContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 10;
	background-color: rgba(255, 255, 255, 0.8);
`;
